import React from 'react';
import { string } from 'prop-types';
import { intlShape } from 'react-intl';
import { path, pathOr } from 'ramda';
import classNames from 'classnames';

import { UserResponseTime } from '../../../components';
import HostAvatar from './HostAvatar/HostAvatar';
import css from './SectionHeading.module.css';

const SectionHeading = (props) => {
  const { className, intl, listing, maxCapacity, params, user } = props;
  const city = path(['attributes', 'publicData', 'location', 'city'], listing);
  const minHourPerBooking = path(['attributes', 'publicData', 'minimumHoursPerBooking'], listing);
  const hasRestroom = pathOr([], ['attributes', 'publicData', 'extras'], listing).includes(
    'toilette'
  );
  const cityText = intl.formatMessage({ id: 'ListingPage.cityText' }, { city: city });
  const capacityText = intl.formatMessage(
    { id: 'Marketplace.participantCount' },
    { count: maxCapacity }
  );
  const minHourPerBookingText = intl.formatMessage(
    { id: 'ListingPage.minHourPerBooking' },
    { count: minHourPerBooking }
  );
  const toiletText = intl.formatMessage({ id: 'ListingPage.restroom' });
  const classes = classNames(css.root, className);

  return (
    <div className={classes}>
      <div className={css.listingInfosContainer}>
        {city && <span className={css.city}>{cityText}</span>}
        <div className={css.wrapper}>
          <span>{capacityText}</span>
          {minHourPerBooking > 1 && <span>{` • ${minHourPerBookingText}`}</span>}
          {hasRestroom && <span>{` • ${toiletText}`}</span>}
        </div>
        {user ? <UserResponseTime user={user} /> : null}
      </div>
      <HostAvatar className={css.hostAvatar} params={params} user={user} />
    </div>
  );
};

SectionHeading.defaultProps = {
  className: null,
};

SectionHeading.propTypes = {
  className: string,
  titleClassName: string.isRequired,
  intl: intlShape.isRequired,
};

export default SectionHeading;
